import { getComStrategys } from '@m2h/common/webApi/abStrategy';

// 添加ab实验头
export function addGlobalexp(config) {
  return {
    ...config,
    headers: {
      ...config.headers,
      globalexp: getComStrategys(true),
    },
  };
}
